import { boolean, intersect, nullable, partial, string, struct } from 'io-ts/Decoder';

import { Id as CustomerId } from '../customer/Id';
import { Id as OrganizationId } from '../organization/Id';

import { Id } from './Id';

export const RefItem = intersect(
	struct({
		id: Id,
	})
)(
	partial({
		name: string,
		organizationId: OrganizationId,
		customerId: nullable(CustomerId),

		isDeleted: boolean,
		isUnknown: boolean,
	})
);
